import { ComponentType, ReactNode } from "react";

//error-pages
import PageNotFound from "../pages/error-pages/PageNotFound";
import PageUnderConstruction from "../pages/error-pages/PageUnderConstruction";

import Home from "../pages/Home";
import { policyRoutes } from "./policyRoutes";
import { aboutRoutes } from "./aboutRoutes";
import ContactUs from "../pages/ContactUs";
import MandatoryDisclosure from "../pages/MandatoryDisclosure";
import { administrationRoutes } from "./administrationRoutes";
import OurSchoolManager from "../pages/OurSchoolManager";
import { academicRoutes } from "./academicRoutes";
import Gallery from "../pages/gallery/Gallery";
import Admission from "../pages/Admission/Admission";
import Event from "../pages/Event/EventGallery";

export interface RouteItem {
  key: string;
  title: string;
  description?: string;
  tooltip: string;
  path: string;
  component?: ReactNode;
  enabled: boolean;
  icon?: ComponentType;
  subRoutes?: Array<RouteItem>;
  appendDivider?: boolean;
  subRoutesDirection?: string;
}

export const routes: Array<RouteItem> = [
  //error page route
  {
    key: "router-error",
    title: "Error",
    tooltip: "Page Not Found",
    path: "*",
    enabled: true,
    component: <PageNotFound />,
    appendDivider: true,
  },
  //home page route
  {
    key: "router-home",
    title: "Home",
    description:
      "St. Xavier's School, Gultekdi, Pune, is a is a CBSE-affiliated (Affiliation No. 1131476) Co-Ed. School established in 2023. It is named after St. Francis Xavier, a 16th-century saint renowned for his extensive mission in Asia under the Portuguese Empire.",
    tooltip: "Home",
    path: "/",
    enabled: true,
    component: <Home />,
    appendDivider: true,
  },

  //about-us route
  aboutRoutes,
  //Administration Route
  administrationRoutes,
  //Academic Route
  academicRoutes,
  //Admission Route
  {
    key: "router-admission",
    title: "Admission",
    tooltip: "Admission",
    path: "/admission",
    enabled: true,
    component: <Admission />,
    appendDivider: true,
  },
  //Gallery
  {
    key: "router-gallery",
    title: "Gallery",
    tooltip: "Gallery",
    path: "/gallery",
    enabled: true,
    component: <Gallery />,
    appendDivider: true,
  },
    {
    key: "router-event",
    title: "Event",
    tooltip: "Event",
    path: "/event",
    enabled: true,
    component: <Event />,
    appendDivider: true,
  },
  // //Notice Board
  // {
  //   key: "router-notice-board",
  //   title: "Notice Board",
  //   tooltip: "Notice Board",
  //   path: "/notice-board",
  //   enabled: true,
  //   component: <PageUnderConstruction />,
  //   appendDivider: true,
  // },
  //Mandatory Disclosure
  {
    key: "router-mandatory-disclosure",
    title: "Mandatory Disclosure",
    tooltip: "Mandatory Disclosure",
    path: "/mandatory-disclosure",
    enabled: true,
    component: <MandatoryDisclosure />,
    appendDivider: true,
  },
  // //careers
  // {
  //   key: "router-careers",
  //   title: "Careers",
  //   tooltip: "Careers",
  //   path: "/careers",
  //   enabled: true,
  //   component: <PageUnderConstruction />,
  //   appendDivider: true,
  // },
  //contact
  {
    key: "router-contact-us",
    title: "Contact Us",
    description:
      "We are here to help and answer any questions you might have. We look forward to hearing from you!",
    tooltip: "Contact Us",
    path: "/contact-us",
    enabled: true,
    component: <ContactUs />,
    appendDivider: true,
  },
  {
    key: "router-school-manager",
    title: "The School Manager",
    tooltip: "The School Manager",
    path: "/school-manager",
    component: <OurSchoolManager />,
    enabled: true,
    appendDivider: true,
  },
  policyRoutes,
];
export default RouteItem;
